export class SellerAccountModel {
  id: string = '';
  accountId: string = '';
  fantasia: string = '';
}

export class UserModel {
  id: string = '';
  name: string = '';
  email: string = '';
  password: string = '';
  verify: boolean = false;
  admin: boolean = false;
  roles: string[] = [];
  identities: string[] = [];
  hasPassword: boolean = true;
  whatsappPhone: string | null = null;
  pendingPhone: string | null = null;
  mfaEnabled: boolean = false;
  parceiro?: number;
  accounts: SellerAccountModel[] = [];
}

export class UserListModel {
  id: string = '';
  email: string = '';
}
